import { MapGroupId } from "../../types";
import img from "../../mapImages/ShorelineMain2D.webp";

const mapData = {
  groupId: MapGroupId.Shoreline,
  groupName: {
    en: "Shoreline",
    ru: "Берег",
  },
  title: {
    en: "Main 2D",
    ru: "Главная 2D",
  },
  imgPath: img,
  extracts: [],
};

export default mapData;
